import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "../config/site";

const GRID = [
  {
    img: IMAGES.family,
    alt: "Family shopping for garments and essentials together",
    label: "For the whole family",
    cls: "md:col-span-2 md:row-span-2 h-72 md:h-full",
  },
  {
    img: IMAGES.kids,
    alt: "Neatly stacked colourful folded garments",
    label: "Everyday garments",
    cls: "h-56 md:h-auto",
  },
  {
    img: IMAGES.saree,
    alt: "Elegant traditional wear and saree fabrics",
    label: "Traditional & occasion",
    cls: "h-56 md:h-auto",
  },
  {
    img: IMAGES.home,
    alt: "Soft pillows and comfortable bedding essentials",
    label: "Home comfort",
    cls: "h-56 md:h-auto",
  },
  {
    img: IMAGES.sandals,
    alt: "Comfortable everyday sandals for women",
    label: "Daily footwear",
    cls: "h-56 md:h-auto",
  },
];

export const Essentials = () => (
  <section className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Everyday Essentials</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
          Your Everyday Essentials, <span className="italic text-gold">Sorted.</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-cream/55 leading-relaxed">
          From garments and footwear to innerwear, bags, accessories, pillows
          and mattresses — Om Sri Sri Collection brings together the essentials
          you need for everyday life, all in one convenient destination.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-5 lg:gap-6 md:h-[560px]">
        {GRID.map((g, i) => (
          <Reveal key={g.label} delay={i * 0.07} className={g.cls}>
            <figure className="group relative w-full h-full rounded-3xl overflow-hidden border border-white/10">
              <img
                src={g.img}
                alt={g.alt}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.05]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent" />
              <figcaption className="absolute bottom-5 left-5 font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] text-cream/85">
                {g.label}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
